export default __webpack_public_path__ + "static/media/chevron-right.06b932fb.svg";